import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogProcessingModalComponent } from '../../dialog/dialog-processing-modal/dialog-processing-modal.component';
import { DialogSuccessModalComponent } from '../../dialog/dialog-success-modal/dialog-success-modal.component';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { DialogErrorModalComponent } from '../../dialog/dialog-error-modal/dialog-error-modal.component';

//Services
@Injectable({
  providedIn: 'root', // Make the service available throughout the application
})
export class AceDialogs {
  #_dialog = inject(MatDialog);
  appGeneralState = inject(AppGeneralStateService);
  dialogHandle: MatDialogRef<DialogProcessingModalComponent>;

  showProcessingDialog(
    displayMessage: string,
    displaySecondaryMessage: string,
  ): MatDialogRef<DialogProcessingModalComponent> {
    try {
      this.appGeneralState.isProcessing = true;

      this.dialogHandle = this.#_dialog.open(DialogProcessingModalComponent, {
        data: { messageMain: displayMessage, messageSecondary: displaySecondaryMessage },
        hasBackdrop: false,
        // height: '550px',
        width: '85vw',
        maxWidth: '100vw',
        panelClass: 'processing-dialog',
        position: {
          top: '200px',
        },
      });
    } catch (err) {
      this.appGeneralState.isProcessing = false;
      //todo put error message here
    }

    return this.dialogHandle;
  }

  closeProcessingDialog(): void {
    this.dialogHandle.close();
  }

  showSuccessDialog(successMessage: string): void {
    this.appGeneralState.isProcessing = false;
    this.dialogHandle.close();
    this.#_dialog.open(DialogSuccessModalComponent, {
      data: { successMessage: successMessage },
      hasBackdrop: false,
      width: '85vw',
      maxWidth: '100vw',
      position: {
        top: '200px',
      },
    });

    setTimeout(() => {
      this.#_dialog.closeAll();
    }, 3000);
  }

  public showErrorDialog(primaryErrMessage: string, secondaryErrMessage: string, errorNumber: string): void {
    this.appGeneralState.isProcessing = false;
    this.#_dialog.open(DialogErrorModalComponent, {
      data: {
        displayErrorMainMessage: primaryErrMessage,
        displayErrorSecondaryMessage: secondaryErrMessage,
        displayErrorNumber: errorNumber,
      },
      hasBackdrop: false,
      width: '60vw',
      maxWidth: '100vw',
      position: {
        top: '200px',
      },
      // maxHeight: '850px',
    });
  }
}
